{
  "form": {
    "appendOnly": "The current version is not removed. What you save becomes a new version, and both stay in the record with who wrote them.",
    "requiredHint": "Fields without a note must be filled in.",
    "optional": "optional",
    "save": "Save",
    "saving": "Saving …",
    "cancel": "Cancel",
    "close": "Close",
    "discardQuestion": "Close the form? What you have written will not be saved.",
    "discardConfirm": "Close without saving",
    "discardCancel": "Keep filling in"
  },
  "notAnswered": "Not recorded",
  "section": {
    "heading": "Document and change allergies and warnings",
    "allergiesHeading": "Allergy entries in the record",
    "flagsHeading": "Safety flags in the record",
    "noAllergies": "No allergy entries in the record.",
    "noFlags": "No safety flags in the record."
  },
  "allergy": {
    "headingDocument": "Document an allergy",
    "headingCorrect": "Change an allergy entry",
    "openDocument": "Document an allergy",
    "openCorrect": "Change allergy",
    "openCorrectNamed": "Change allergy: {substance}",
    "explanationDocument": "For an allergy or hypersensitivity that is not in the record. The substance is shown at the top of the patient overview, without scrolling.",
    "explanationCorrect": "For an allergy entry that was wrong. Choose Entered in error if the entry should never have been documented at all.",
    "savedDocument": "The allergy is documented.",
    "savedCorrect": "The change is saved.",
    "fieldStatus": "Status",
    "fieldSubstance": "Substance",
    "fieldReaction": "Reaction",
    "fieldSeverity": "Severity",
    "fieldCriticality": "Risk on re-exposure",
    "fieldVerification": "Confirmed",
    "hintStatus": "Choose No known allergies when the question has been asked and the answer is no. That is an entry in the record, not an empty list.",
    "hintSubstance": "A drug, a substance or a food, under the name used here. The text is never translated.",
    "hintReaction": "What happened on exposure.",
    "hintSeverity": "Leave empty if the severity has not been established. Empty does not mean mild.",
    "hintCriticality": "How dangerous a further exposure is judged to be. Not the same as how severe the reaction was.",
    "hintVerification": "Leave empty if it has not been established.",
    "statusActive": "Current",
    "statusResolved": "Resolved",
    "statusNoKnownAllergies": "No known allergies",
    "statusEnteredInError": "Entered in error",
    "verificationConfirmed": "Confirmed",
    "refusal": {
      "statusInvalid": "The status is not recognised. The allergy was not saved.",
      "statusNotAllowed": "Entered in error cannot be chosen for a new entry — an entry that should not exist is not documented at all. The allergy was not saved.",
      "substanceMissing": "The substance must be filled in. The allergy was not saved.",
      "substanceNotAllowed": "No known allergies cannot be combined with a substance. Remove the substance, or choose another status. The allergy was not saved.",
      "severityInvalid": "The severity is not recognised. The allergy was not saved.",
      "criticalityInvalid": "The risk on re-exposure is not recognised. The allergy was not saved.",
      "verificationInvalid": "The value for Confirmed is not recognised. The allergy was not saved.",
      "notFound": "The allergy entry is not in the record. The change was not saved. Open the patient overview again.",
      "retracted": "The allergy entry is retracted in the record and cannot be changed. The change was not saved. Document a new entry instead if one is needed.",
      "unknown": "The allergy was not saved. Try again."
    }
  },
  "flag": {
    "headingDocument": "Document a safety flag",
    "headingCorrect": "Change a safety flag",
    "openDocument": "Document a safety flag",
    "openCorrect": "Change warning",
    "openCorrectNamed": "Change warning: {type}",
    "explanationDocument": "For isolation, infection risk, fall risk, weight, or allergy status not established. DNR and treatment limitation cannot be documented here — they require the record to say who took the decision and when.",
    "explanationCorrect": "For a safety flag that was wrong. The type cannot be changed; choose Entered in error if the flag should never have been documented at all.",
    "savedDocument": "The safety flag is documented.",
    "savedCorrect": "The change is saved.",
    "correctExisting": "Change the existing one",
    "fieldType": "Type of flag",
    "fieldStatus": "Status",
    "fieldValue": "Entry",
    "fieldWeight": "Weight in kilograms",
    "fieldIsolationType": "Type of isolation",
    "fieldLimitation": "The limitation in brief",
    "fieldNote": "Reasoning",
    "hintType": "The type cannot be changed afterwards. A flag of the wrong type has to be retracted and documented again.",
    "hintStatus": "Choose Resolved when the flag no longer applies, and Entered in error only when it should never have been documented.",
    "hintWeight": "Write the weight with a decimal point: 62.4. A comma is not accepted.",
    "hintIsolationType": "For example droppsmitta or luftsmitta, under the name used here.",
    "hintLimitation": "One line. The reasoning goes in the field below.",
    "hintNote": "The background to the flag.",
    "statusActive": "Current",
    "statusResolved": "Resolved",
    "statusEnteredInError": "Entered in error",
    "refusal": {
      "typeInvalid": "The type of flag is not recognised. The flag was not saved.",
      "typeNotDocumentable": "{type} cannot be documented here: the record requires it to say who took the decision and when, and that cannot be given in this version. The flag was not saved.",
      "typeNotDocumentableUnnamed": "That type of flag cannot be documented here: the record requires it to say who took the decision and when, and that cannot be given in this version. The flag was not saved.",
      "statusInvalid": "The status is not recognised. The flag was not saved.",
      "statusNotAllowed": "Entered in error cannot be chosen for a new flag — a flag that should not exist is not documented at all. The flag was not saved.",
      "valueMissing": "The entry must be filled in for this type of flag. The flag was not saved.",
      "weightMissing": "The weight must be filled in. A weight with no value is worse than none: it reads as though the question had been answered. The flag was not saved.",
      "isolationTypeMissing": "The type of isolation must be filled in. The flag was not saved.",
      "weightComma": "Write the weight with a decimal point: 62.4, not 62,4. The flag was not saved.",
      "weightMalformed": "The weight does not read as a number. Write it with digits and a decimal point: 62.4. The flag was not saved.",
      "weightNotPositive": "The weight must be greater than zero. The flag was not saved.",
      "alreadyDocumented": "The patient already has a flag of type {type}. Change that one instead — it is the one shown on the overview. No new flag was saved.",
      "alreadyDocumentedUnnamed": "The patient already has a flag of that type. Change that one instead — it is the one shown on the overview. No new flag was saved.",
      "notFound": "The safety flag is not in the record. The change was not saved. Open the patient overview again.",
      "retracted": "The safety flag is retracted in the record and cannot be changed. The change was not saved. Document a new flag instead if one is needed.",
      "unknown": "The flag was not saved. Try again."
    }
  },
  "refusal": {
    "fieldTooLong": "{field} is too long. At most {maximum} characters. Nothing was saved.",
    "versionStale": "Somebody else saved a new version while the form was open. Open the patient overview again and check what it says. What you wrote was not saved.",
    "noChange": "Nothing differs from what the record holds. No new version was written.",
    "supersedesWrong": "The form and the record disagree about which version it started from. Close the patient overview and open it again. Nothing was saved.",
    "patientNotFound": "The patient is not in the record. Nothing was saved.",
    "patientRetracted": "The patient is retracted in the record. Nothing was saved.",
    "roleMayNotDocument": "Your role may not document in the record. Nothing was saved.",
    "unavailable": "No contact with the server. Nothing was saved — leave the form open and try again."
  }
}
